import { SecureWebhookTypes } from "@enums/secure-webhook-types";
import { SelectOption } from "@idw-types/common";

export const SECURE_WEBHOOK_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "None", value: SecureWebhookTypes.NONE },
    { label: "OAuth 2.0", value: SecureWebhookTypes.OAUTH },
    { label: "Basic", value: SecureWebhookTypes.BASIC },
];